import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserDetailsContext } from "../context/userDetails";
import { CLOTHING_SCAN_WITH_TRY_ON, CLOTHING_SCAN_ONLY, CLOTHING_TRY_ON_SCAN, GETTING_STARTED, CLOTHING_SCAN, CLOTHING_BANNER_SCAN, CLOTHING_CUSTOM_SCAN, CLOTHING_TRYON_CONSUMER_SCAN } from "../vars";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";

function ScreenWrapper({ children }) {
	const { scanType, loading } = useContext(UserDetailsContext);
	if (!scanType) return <LoadingScreen className="h-full w-full desktop-wrapper fitViewScreen flex alignCenter justifyCenter" />;

	if (loading) {
		return <LoadingScreen className="h-full w-full desktop-wrapper fitViewScreen flex alignCenter justifyCenter" />;
	}
	switch (scanType) {
		case CLOTHING_SCAN_WITH_TRY_ON:
		case CLOTHING_TRY_ON_SCAN:
		case CLOTHING_TRYON_CONSUMER_SCAN:
			return <Navigate to={GETTING_STARTED} replace />;
		case CLOTHING_SCAN_ONLY:
		case CLOTHING_SCAN:
		case CLOTHING_BANNER_SCAN:
		case CLOTHING_CUSTOM_SCAN:
			return children;
		default:
			return children;
	}
}

export default ScreenWrapper;
